import { GenIcon } from '../helpers/IconBase.es.js';

const CircleShippingColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "12", fill: "#FFFFF0" }
      },
      {
        tag: "path",
        attr: {
          d: "M8.3998 9.15007C8.3998 8.90167 8.1982 8.70007 7.9498 8.70007H5.2498C5.0014 8.70007 4.7998 8.90167 4.7998 9.15007C4.7998 9.39847 5.0014 9.60007 5.2498 9.60007H7.9498C8.1982 9.60007 8.3998 9.39847 8.3998 9.15007Z",
          fill: "#FFC107"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.94971 10.5H6.14971C5.90131 10.5 5.69971 10.7016 5.69971 10.95C5.69971 11.1984 5.90131 11.4 6.14971 11.4H7.94971C8.19811 11.4 8.39971 11.1984 8.39971 10.95C8.39971 10.7016 8.19811 10.5 7.94971 10.5Z",
          fill: "#FFC107"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.94961 12.3H7.04961C6.80121 12.3 6.59961 12.5016 6.59961 12.75C6.59961 12.9984 6.80121 13.2 7.04961 13.2H7.94961C8.19801 13.2 8.39961 12.9984 8.39961 12.75C8.39961 12.5016 8.19801 12.3 7.94961 12.3Z",
          fill: "#FFC107"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.1359 12.0688L17.7859 9.8188C17.7049 9.6829 17.5582 9.6001 17.3998 9.6001H14.2498C14.0014 9.6001 13.7998 9.8017 13.7998 10.0501V14.5501C13.7998 14.7985 14.0014 15.0001 14.2498 15.0001H18.7498C18.9982 15.0001 19.1998 14.7985 19.1998 14.5501V12.3001C19.1998 12.2182 19.1782 12.1381 19.1359 12.0688Z",
          fill: "#F44336"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.5996 10.5H17.1449L18.2249 12.3H15.5996V10.5Z",
          fill: "#FAFAFA"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.25 7.80005H7.95C7.7016 7.80005 7.5 8.00165 7.5 8.25005V14.55C7.5 14.7984 7.7016 15 7.95 15H14.7V8.25005C14.7 8.00165 14.4984 7.80005 14.25 7.80005Z",
          fill: "#FFC107"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.9498 15.45C17.4469 15.45 17.8498 15.0471 17.8498 14.55C17.8498 14.053 17.4469 13.65 16.9498 13.65C16.4527 13.65 16.0498 14.053 16.0498 14.55C16.0498 15.0471 16.4527 15.45 16.9498 15.45Z",
          fill: "#FAFAFA"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.9496 15.9001C16.2053 15.9001 15.5996 15.2944 15.5996 14.5501C15.5996 13.8058 16.2053 13.2001 16.9496 13.2001C17.6939 13.2001 18.2996 13.8058 18.2996 14.5501C18.2996 15.2944 17.6939 15.9001 16.9496 15.9001ZM16.9496 14.1001C16.7021 14.1001 16.4996 14.3026 16.4996 14.5501C16.4996 14.7976 16.7021 15.0001 16.9496 15.0001C17.1971 15.0001 17.3996 14.7976 17.3996 14.5501C17.3996 14.3026 17.1971 14.1001 16.9496 14.1001Z",
          fill: "#455A64"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.7 15.0001H7.95C7.7016 15.0001 7.5 14.7985 7.5 14.5501V13.2001H14.7V15.0001Z",
          fill: "#F44336"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.65 15.45C11.1471 15.45 11.55 15.0471 11.55 14.55C11.55 14.053 11.1471 13.65 10.65 13.65C10.1529 13.65 9.75 14.053 9.75 14.55C9.75 15.0471 10.1529 15.45 10.65 15.45Z",
          fill: "#FAFAFA"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.6498 15.9001C9.9055 15.9001 9.2998 15.2944 9.2998 14.5501C9.2998 13.8058 9.9055 13.2001 10.6498 13.2001C11.3941 13.2001 11.9998 13.8058 11.9998 14.5501C11.9998 15.2944 11.3941 15.9001 10.6498 15.9001ZM10.6498 14.1001C10.4014 14.1001 10.1998 14.3026 10.1998 14.5501C10.1998 14.7976 10.4014 15.0001 10.6498 15.0001C10.8982 15.0001 11.0998 14.7976 11.0998 14.5501C11.0998 14.3026 10.8982 14.1001 10.6498 14.1001Z",
          fill: "#455A64"
        }
      }
    ]
  })(props);
};

export { CircleShippingColored };
